import { captureAnalytics } from './captureAnalytics';

const delayedCaptureAnalytics = () =>
  setTimeout(() => captureAnalytics(), 1000);

export const analyticsInit = () => {
  window.addEventListener('load', delayedCaptureAnalytics, false);
};
